import React, { useCallback } from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./DownloadToPlayModal.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import { GenericModalProps } from "../../../utils/constants/generic-types";
import GetAppButton from "../../GetAppButton/GetAppButton";
import DownloadAndroidAppModal from "../../DownloadAndroidAppModal/DownloadAndroidAppModal";
import useDisclosure from "../../../hooks/useDisclosure";
import useGetApp from "../../../hooks/useGetApp";
import ImageAppWinPreview from "../../../images/app-win-preview.png";

function DownloadToPlayModal({ isOpen, onClose }: GenericModalProps) {
  const { t } = useTranslation("games");
  const { t: tCommon } = useTranslation("common");
  const { appExists } = useGetApp();
  const {
    isOpen: isAndroidAppDownloadOpen,
    onOpen: openDownloadAndroidApp,
    onClose: closeDownloadAndroidApp,
  } = useDisclosure();

  const handleOpenAndroidDownload = useCallback(() => {
    onClose();
    openDownloadAndroidApp();
  }, [onClose, openDownloadAndroidApp]);

  return (
    <>
      <BottomDrawer
        isOpen={isOpen}
        onClose={onClose}
        containerClass="download-to-play-drawer"
      >
        <div className="download-to-play-modal">
          <h2>{t("download_to_play_modal.title")}</h2>
          <p>{t("download_to_play_modal.content")}</p>
          <div className="download-to-play-visual">
            <Image
              src={ImageAppWinPreview}
              alt=""
              width={238}
              height={407}
              className="win-preview"
            />
            <div className="get-app-button-wrap">
              <GetAppButton
                label={appExists ? tCommon("use_app") : tCommon("download_app")}
                openDownloadAndroidApp={handleOpenAndroidDownload}
              />
            </div>
          </div>
        </div>
      </BottomDrawer>
      <DownloadAndroidAppModal
        isOpen={isAndroidAppDownloadOpen}
        onClose={closeDownloadAndroidApp}
      />
    </>
  );
}

export default DownloadToPlayModal;
